import Vue from 'vue';
import store from './../../store';
import subscriberTransformer from './../../transformers/subscriber';
import paginationTransformer from '../../transformers/pagination';

const success = ({ data }, resolve) => {
  const subscriber = subscriberTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);
  store.dispatch('fetchPaginatedSubscriber', { subscriber, pagination });
  resolve({ subscriber, pagination });
};

const failed = (error, reject) => reject(error);


export default (id, page = 1, limit = 10, filter) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`subscriberList/${id}/indexSubscriber?page=${page}&limit=${limit}&filter=${filter}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriber/items.js